const PRODUCTS_CACHE_PREFIX = 'webstore-available-products:';
export const WEBSTORE_LAST_STORE_KEY = 'webstore-last-store';

const isValidCacheEntry = (parsed) => (
  parsed
  && typeof parsed === 'object'
  && Array.isArray(parsed.products)
  && typeof parsed.fetchedAt === 'string'
);

export const readAvailableProductsCache = (store) => {
  try {
    const raw = sessionStorage.getItem(`${PRODUCTS_CACHE_PREFIX}${store}`);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    // New shape: { products, fetchedAt }. Ignore legacy bare-array caches.
    return isValidCacheEntry(parsed) ? parsed : null;
  } catch (error) {
    return null;
  }
};

export const writeAvailableProductsCache = (store, { products, fetchedAt }) => {
  if (!Array.isArray(products) || !fetchedAt) {
    return;
  }
  try {
    sessionStorage.setItem(
      `${PRODUCTS_CACHE_PREFIX}${store}`,
      JSON.stringify({ products, fetchedAt }),
    );
  } catch (error) {
    // Quota / private mode — ignore
  }
};

export const rememberWebstoreStore = (store) => {
  try {
    localStorage.setItem(WEBSTORE_LAST_STORE_KEY, store);
  } catch (error) {
    // Ignore
  }
};

export const getRememberedWebstoreStore = (validStores) => {
  try {
    const last = localStorage.getItem(WEBSTORE_LAST_STORE_KEY);
    if (last && validStores.includes(last)) {
      return last;
    }
  } catch (error) {
    // Ignore
  }
  return null;
};
